export default __webpack_public_path__ + "static/media/img11.dee8f800.png";